<template>
  <div class="propertysupervise">
    <div class="header">
      <div class="title">智能家居</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <div class="logo">
          <img :src="ResidentSupervise1" alt="" />
        </div>
        <div class="position">
          <img :src="ResidentSupervise2" alt="" />
          <img :src="ResidentSupervise3" alt="" />
          <img :src="ResidentSupervise4" alt="" />
        </div>
      </div>

      <div class="right">
        智能家电、智能门锁、智能照明等设备，一键轻松连接，体验不一样的社区智能化家居生活。
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import ResidentSupervise1 from "../../../../assets/product/ResidentSupervise1.png";
import ResidentSupervise2 from "../../../../assets/product/ResidentSupervise2.png";
import ResidentSupervise3 from "../../../../assets/product/ResidentSupervise3.png";
import ResidentSupervise4 from "../../../../assets/product/ResidentSupervise4.png";

export default {
  setup() {
    return reactive({
      ResidentSupervise1: ResidentSupervise1,
      ResidentSupervise2: ResidentSupervise2,
      ResidentSupervise3: ResidentSupervise3,
      ResidentSupervise4: ResidentSupervise4,
    });
  },
};
</script>

<style scoped>
.propertysupervise {
  width: 1180px;
  margin: 80px auto;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.body .left {
  display: flex;
  position: relative;
}
.body .left .logo img {
  width: 332px;
  margin-right: 20px;
}
.body .left .position img {
  width: 236px;
  position: absolute;
}
.body .left .position img:nth-of-type(1) {
  left: 100%;
}
.body .left .position img:nth-of-type(2) {
  left: 125%;
  bottom: 0;
}
.body .left .position img:nth-of-type(3) {
  left: 150%;
  bottom: 0;
}
.body .right {
    width: 480px;
    font-size: 16px;
    color: #3D3D3D;
    line-height: 24px;
}
</style>
